import { GlobalOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import type { MenuProps } from "antd";
import { useTranslation } from "react-i18next";
import { useAuth } from "../hooks/useAuth";
import api from "../services/api";

const LANGUAGES: { code: string; label: string }[] = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
];

export default function LanguageSwitcher(): JSX.Element {
  const { i18n } = useTranslation();
  const { isLoggedIn, currentUser } = useAuth();

  const items: MenuProps["items"] = LANGUAGES.map(({ code, label }) => ({
    key: code,
    label,
  }));

  const currentLabel = LANGUAGES.find((lang) => lang.code === i18n.resolvedLanguage)?.label;

  const handleChange = (code: string): void => {
    i18n.changeLanguage(code);
    // Persist as the user's default language so it follows them across devices
    if (isLoggedIn && currentUser) {
      api.patch(`/users/${currentUser.id}`, { preferred_language: code }).catch((err) => {
        console.error("Failed to save language preference:", err);
      });
    }
  };

  return (
    <Dropdown
      menu={{
        items,
        selectedKeys: i18n.resolvedLanguage ? [i18n.resolvedLanguage] : [],
        onClick: ({ key }) => handleChange(key),
      }}
    >
      <span style={{ color: "white", cursor: "pointer" }}>
        <GlobalOutlined /> {currentLabel}
      </span>
    </Dropdown>
  );
}
